import { render, staticRenderFns } from "./BusinessQuery.vue?vue&type=template&id=2d450061&scoped=true"
import script from "./BusinessQuery.vue?vue&type=script&lang=js"
export * from "./BusinessQuery.vue?vue&type=script&lang=js"
import style0 from "./BusinessQuery.vue?vue&type=style&index=0&id=2d450061&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d450061",
  null
  
)

export default component.exports